import { render, staticRenderFns } from "./BeeAttributeInput.vue?vue&type=template&id=758ffc56&"
import script from "./BeeAttributeInput.vue?vue&type=script&lang=js&"
export * from "./BeeAttributeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports